import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Handle numeric-only input for tel type inputs
 * Allows only digits, decimal point, and minus sign for negative numbers
 * @param {Event} e - The input event
 * @param {boolean} allowDecimal - Whether to allow decimal point (default: true)
 * @param {boolean} allowNegative - Whether to allow negative numbers (default: false)
 */
export function handleNumericInput(e, allowDecimal = true, allowNegative = false) {
  let pattern = allowDecimal ? /[^0-9.]/g : /[^0-9]/g;
  if (allowNegative) {
    pattern = allowDecimal ? /[^0-9.-]/g : /[^0-9-]/g;
  }
  e.target.value = e.target.value.replace(pattern, '');
  
  // Ensure only one decimal point
  if (allowDecimal) {
    const parts = e.target.value.split('.');
    if (parts.length > 2) {
      e.target.value = parts[0] + '.' + parts.slice(1).join('');
    }
  }
  
  // Ensure minus is only at the start
  if (allowNegative && e.target.value.includes('-')) {
    const hasLeadingMinus = e.target.value.startsWith('-');
    e.target.value = e.target.value.replace(/-/g, '');
    if (hasLeadingMinus) {
      e.target.value = '-' + e.target.value;
    }
  }
}

/**
 * Prevent non-numeric key presses for tel inputs
 * @param {KeyboardEvent} e - The keydown event
 * @param {boolean} allowDecimal - Whether to allow decimal point (default: true)
 * @param {boolean} allowNegative - Whether to allow negative numbers (default: false)
 */
export function preventNonNumericInput(e, allowDecimal = true, allowNegative = false) {
  // Allow: backspace, delete, tab, escape, enter, arrows
  const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
  
  if (allowedKeys.includes(e.key)) {
    return;
  }
  
  // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
  if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())) {
    return;
  }
  
  // Allow decimal point (only one)
  if (allowDecimal && e.key === '.' && !e.target.value.includes('.')) {
    return;
  }
  
  // Allow minus sign (only at start)
  if (allowNegative && e.key === '-' && e.target.selectionStart === 0 && !e.target.value.includes('-')) {
    return;
  }
  
  // Allow numbers
  if (/^[0-9]$/.test(e.key)) {
    return;
  }
  
  // Prevent all other keys
  e.preventDefault();
}
